module.exports = __webpack_public_path__ + "img/main_zs.9fcee66c.png";